<template>
  <div id="wrapper">
    <SidebarView :allCoa="true" :accounts="true" :accounts-visible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="mx-3">
          <div class="card card-shape home-box">
            <div class="card-header d-flex flex-row align-items-center justify-content-between">
              <!-- <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="m-0 fw-bold text-green">Chart Of Accounts</h6>
                </div>
                <add-coa-head @coa-head-saved="coaHeadSaved" ref="modal">
                </add-coa-head>
              </div> -->
              <h6 class="m-0 fw-bold text-green">Chart Of Accounts</h6>
              <add-coa-head @coa-head-saved="coaHeadSaved" ref="modal">
              </add-coa-head>
            </div>
            <div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115)">
              <div class="home-box border border-success py-1 bg-white">
                <div class="card-body">
                  <form @submit.prevent="filterTable">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <label class="akkurate-dark small d-none d-lg-block" for="search">Search</label>
                        <b-form-group id="search" label-for="search" class="akkurate-dark">
                          <b-form-input id="search" class="mt-2 field-container fields" type="text"
                            v-model="search_form.search" placeholder="Search by Heads, Subheads...">
                          </b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col">
                        <label class="akkurate-dark small d-none d-lg-block" for="branch">Select Branches:</label>
                        <multiselect :disabled="add_or_edit == 'edit'" v-model="search_form.selected_branches"
                          :multiple="true" name="selected_branches" placeholder="Search or select" :options="branches"
                          label="name" track-by="id" class="rounded-0"></multiselect>
                      </div>

                      <div class="col">
                        <label class="akkurate-dark small d-none d-lg-block" for="branch">Categories:</label>
                        <multiselect :disabled="add_or_edit == 'edit'" v-model="search_form.categories" :multiple="true"
                          name="selected_categories" placeholder="Search or select" :options="categories"></multiselect>
                      </div>

                      <div class="col-2 mt-auto">
                        <b-button type="submit" class="akkurate-green-btn akkurate-auth-size"
                          style="color: white;"><font-awesome-icon class="me-2"
                            :icon="['fas', 'forward']" />Go</b-button>
                        <b-button @click.prevent="linkAllCOA" class="akkurate-green-btn akkurate-auth-size mx-2"
                          style="color: white;">
                          <span v-if="isLoadingLink">
                            <b-spinner small class="align-middle"></b-spinner>
                          </span>
                          <font-awesome-icon v-else :icon="['fas', 'link']" /></b-button>
                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </div>
            <div class="card-body table_text_size">
              <b-table-simple small bordered outlined>
                <b-thead variant="secondary">
                  <b-tr class="text-start">
                    <b-th variant="danger">Number</b-th>
                    <b-th>Name</b-th>
                    <b-th>Type</b-th>
                    <b-th>Balance</b-th>
                    <b-th>Branch</b-th>
                    <b-th>Action</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody v-for="(row, index) in displayedRows" :key="index" class="">
                  <b-tr class="text-start">
                    <b-td class="fw-bold" variant="success"><span class="dark-green">{{ row.code }}</span></b-td>
                    <b-td class="fw-bold" variant="success"><span class="dark-green">{{ row.display_name }}</span></b-td>
                    <b-td class="fw-bold" variant="success"><span  class="dark-green">{{ row.headtype?.name }}</span></b-td>
                    <b-td class="fw-bold" variant="success"></b-td>
                    <b-td class="fw-bold" variant="success"><span class="dark-green">{{ row.headbranch?.name }}</span></b-td>
                    <b-td class="fw-bold" variant="success">
                      <add-coa-sub-type :account_types="account_types" :branches="branches" :coa_head="row"
                        @coa-sub-head-saved="loadPageOptions"></add-coa-sub-type>
                    </b-td>
                  </b-tr>
                  <b-tr v-for="(subhead, index1) in row.subheads" :key="index1">
                    <b-td>
                       <b-link v-b-tooltip.hover="{ variant: 'info' }" title="Click to view ledger entries"
                        class="text-decoration-none akkurate-green"
                        :href="`/chart-of-accounts/transactions?coa_code=${subhead.code}`">
                        {{ subhead.code }}
                      </b-link>
                    </b-td>
                    <b-td>{{ subhead?.name }}</b-td>
                    <b-td>{{ row.headtype?.name }}</b-td>
                    <b-td>{{ displayNumber(subhead.amount) }}</b-td>
                    <b-td>{{ subhead.coabranch?.name }}</b-td>
                    <b-td class="d-flex">
                      <edit-coa-sub-type :subhead="subhead" :account_types="account_types" :branches="branches"
                        :coa_head="row" :coa_heads="coa_heads" @coa-sub-head-saved="loadPageOptions">
                      </edit-coa-sub-type>
                      <b-button @click.prevent="rewriteCOA(subhead.id)" class="akkurate-green-btn akkurate-small"
                        style="color: white;">
                        <span v-if="isLoadingLink">
                          <b-spinner small class="align-middle"></b-spinner>
                        </span>
                        <font-awesome-icon v-else :icon="['fas', 'arrow-rotate-left']" /></b-button>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <div class="d-flex justify-content-between pt-1">
                <b-pagination v-model="currentPage" :total-rows="coa_heads.length" :per-page="Number(perPage)"
                  @change="navigatePage"></b-pagination>

                <div class="col text-end mt-1">
                  <div>
                    {{ currentPage }} of {{ totalPages }}
                  </div>
                  <b-form-group label="Per Page" label-size="sm" class="mb-0">
                    <b-form-select @change="selectPerPage" id="per-page-select" v-model="perPage"
                      :options="per_page_options" size="sm"></b-form-select>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>

    <!-- AI -->
    <ChatBot />
    <!-- End AI -->
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>


<script>
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import AddAccountType from "./../../account-types/forms/AddAccountType.vue";
import AddCoaHead from "./../AddCoaHead.vue";
import AddCoaSubType from "./../AddCoaSubType.vue";
import TransferCoaSubhead from "../TransferCoaSubhead.vue";
import EditCoaSubType from '../EditCoaSubType.vue'
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
  components: {
    Multiselect,
    SidebarView,
    TopbarView,
    Footer,
    AddAccountType,
    AddCoaHead,
    AddCoaSubType,
    TransferCoaSubhead,
    EditCoaSubType,
    ChatBot,
  },
  mounted() {
    this.loadPageOptions();
  },
  //   props:["coa_head"],
  data() {
    return {
      isLoading: false,
      form: {
        coa_head: this.coa_head,
        account_number: "",
      },
      search_form: {
        selected_branches: [],
        categories: [],
        search:"",

      },
      isLoadingLink: false,
      add_or_edit: "add",
      branches: [],
      categories: ['STANDARD', 'PRODUCT', 'USER'],
      account_types: [],
      coa_heads: [],
      currentPage: 1,
      rowsPerPage: 5,
      perPage: "5",
      per_page_options: ['5', '10', '20'],
      per_page_selected: "10",
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.coa_heads.length / Number(this.perPage));
    },
    displayedRows() {
      const startIndex = (this.currentPage - 1) * Number(this.perPage);
      const endIndex = startIndex + Number(this.perPage);
      return this.coa_heads.slice(startIndex, endIndex);
    },
  },
  methods: {
    openCOASubTypeModal() {
      $("#" + this.coa_head.id).modal("show");
    },
    coaHeadSaved() {
      // this.onChangePage(1);
      this.loadPageOptions()
    },
    filterTable(){
      this.loadPageOptions();
    },
    async loadPageOptions() {
      this.$Progress.start();
      this.isLoading = true;
      this.currentPage = 1;
      await ApiService.post("/finance/chart-of-accounts/dropdown", this.search_form)
        .then((response) => {
          //   this.account_types = response.data.account_types;
          this.account_types = response.data.account_types;
          this.coa_heads = response.data.coa_heads;

          this.branches = response.data.branches;
          this.isLoading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.$Progress.fail();
        });
    },
    async linkAllCOA() {
      this.$Progress.start();
      this.isLoadingLink = true;
      this.currentPage = 1;
      await ApiService.post("/finance/coa-linking/all")
        .then((response) => {
          this.$Progress.finish();
          this.isLoadingLink = false;
          toast.fire({
            icon: "success",
            title: response.data.message,
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLoadingLink = false;
          this.$Progress.fail();
        });
    },
    async rewriteCOA(id) {
      swal.fire({
        // title: response.data.transaction.trans_status,
        title: "Rewite Ledger",
        // text: 'CODE : ' + response.data.transaction.code,
        text: "Are you sure?",
        confirmButtonColor: "#018673",
        icon: "question",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true, // Show the "Cancel" button
        confirmButtonText: "Yes", // Customize the text for the "OK" button
        cancelButtonText: "No", // Text for the custom button
        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
        customClass: {
          confirmButton:
            "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
          cancelButton:
            "btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          // this.isLoading = true;
          // this.isDisbursing = false;
          // this.$Progress.start();
          // this.$bvModal.hide(
          //   String(this.loan_no + this.statement)
          // );
          await ApiService.post(`/finance/coa-transactions/rewrite/id`, {
            'coa_id': id
          }).then((response) => {
            // console.log(response);
            // this.isLoading = false;
            // this.$Progress.finish();
            toast.fire({
              icon: "success",
              title: response.data.message,
            });
            this.loadPageOptions()
            // this.loadItems();
          })
            .catch((error) => {
              // this.isDisbursing = false;
              // this.isLoading = false;
              // this.$Progress.fail();
              toast.fire({
                icon: "error",
                title: error.response.data.message,
              });
              // if (error.response.data.errors) {
              //     this.form.errors = error.response.data.errors;
              // }
            });
        } else if (result.isDismissed) {
          // this.isDisbursing = false;
          // this.$bvModal.hide(
          //   String(this.loan_no + this.statement)
          // );
        }
      });
    },
    // goToPage(page) {
    //   if (page >= 1 && page <= this.totalPages) {
    //     this.currentPage = page;
    //   }
    // },
    navigatePage(index) {
      if (index >= 1 && index <= this.totalPages) {
        this.currentPage = index;
      }
    },
    selectPerPage(index) {
      this.perPage = index;
      this.currentPage = 1;
    }

  },
};
</script>
<style>
.custom-table {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.row {
  display: flex;
  border-bottom: 1px solid #ccc;
}

.row.header {
  font-weight: bold;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  background-color: #f2f2f2;
  /* Gray background color */

}

.cell {
  flex: 2;
  padding: 8px;
}

.cell-small {
  flex: 1;
  padding: 8px;
}

.cell-2 {
  flex: 4;
  padding: 8px;
}

/* Optional styles to make it look more like a table */
.custom-table {
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}

.row:last-child {
  border-bottom: none;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.pagination button {
  margin: 0 5px;
}
.dark-green{
  color: #047463
}
</style>